export enum LangEnum {
    FR = "fr",
    EN = "en",
    RO = "ro",
}
